import { Component, OnInit, AfterViewInit, ViewChild } from '@angular/core';
import { PesquisaBaseService } from 'src/app/libs/pesquisa/pesquisa-base.service';
import { AtendimentoMeusService } from '../atendimento-meus.service';
import { ActivatedRoute, Router } from '@angular/router';
import { PacienteService } from 'src/app/servicos/paciente.service';
import { UsuarioService } from 'src/app/autenticacao/usuario.service';
import { ToolbarService } from 'src/app/utilitarios/toolbar.service';
import { AgendamentoDto } from 'src/app/dtos/agendamentos/agendamento-dto';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { AgendamentoService } from 'src/app/servicos/agendamento.service';
import { ProfissionalProfissaoTipo } from 'src/app/autenticacao/modelos/usuario';
import { GridComponent, ContextMenuItemModel, ContextMenuOpenEventArgs } from '@syncfusion/ej2-angular-grids';
import { MenuEventArgs } from '@syncfusion/ej2-angular-navigations';
import { ToastService } from 'src/app/libs/toast/toast.service';
import { NaoExecucaoDto } from 'src/app/dtos/atendimentos/nao-execucao-dto';
import { AtendimentoService } from 'src/app/servicos/atendimento.service';
import { ConfirmService } from 'src/app/libs/confirm/confirm.service';
import { ATENDIMENTO, SOLICITACAO } from 'src/app/i18n/constantes';
import { TranslateService } from '@ngx-translate/core';
import { DateRangePresetsService } from '@/app/servicos/date-range-presets.service';


interface PesquisaAgendamentoForm {
  datas: FormControl<Date[]>;
  apenasComAgendamentoVinculado: FormControl<boolean>;
}

@Component({
  selector: 'app-atendimento-meus',
  templateUrl: './atendimento-meus.component.html',
  styleUrls: ['./atendimento-meus.component.less'],
  providers: [PesquisaBaseService]
})
export class AtendimentoMeusComponent implements OnInit, AfterViewInit {

  @ViewChild('grid')
  grid!: GridComponent;

  //teste contextMenu
  @ViewChild('contextmenu')
  contextMenu!: any;

  //teste contextMenu
  public contextMenuItems?: ContextMenuItemModel[];
  //teste contextMenu
  public selectedPerson: any;

  submetido: boolean = false;

  moreFields: boolean = false;

  modelo: FormGroup<PesquisaAgendamentoForm> = this.fb.group<PesquisaAgendamentoForm>({
    datas: this.fb.nonNullable.control<Date[]>([], [Validators.required]),
    apenasComAgendamentoVinculado: this.fb.nonNullable.control<boolean>(false)
  });

  registros: AgendamentoDto[] = [];

  toolbarItens: string[] = [
    'Search', 'ExcelExport', 'CsvExport', 'PdfExport', 'Print'
  ];

  constructor(private servico: AtendimentoMeusService,
    private router: Router,
    private fb: FormBuilder,
    private agendamentoService: AgendamentoService,
    private pacienteService: PacienteService,
    private usuarioServico: UsuarioService,
    private activatedRoute: ActivatedRoute,
    private confirm: ConfirmService,
    public toolbar: ToolbarService,
    public presets: DateRangePresetsService,
    private base: PesquisaBaseService,
    public toast: ToastService,
    public translate: TranslateService,
    private atendimentoServico: AtendimentoService) {
    servico.setarComponente(this);
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.modelo.controls.datas.setValue([this.presets.today, this.presets.today]);
      this.modelo.updateValueAndValidity();
    }, 200);
  }

  ngOnInit(): void {
    //teste contextMenu
    this.contextMenuItems = [
      { text: 'Não compareceu', target: '.e-content', id: 'pacienteAusente' }
    ];
  }

  abrirTelaCheia() {
    this.atualizar();
    this.base.abrirTelaCheia();
  }

  selecionado(registro: AgendamentoDto) {
    const agendamentos = this.grid.getSelectedRecords() as AgendamentoDto[];

    if (agendamentos.length === 0) {
      return;
    }

    this.base.fechar();

    const agendamentoSelecionado = agendamentos[0];
    const pacienteId = agendamentoSelecionado.pacienteId;

    if (!pacienteId) {
      this.toast.showWarning('Paciente não identificado no agendamento selecionado.');
      return;
    }

    const rota = this.usuarioServico.consultarUsuario().profissionalProfissaoTipo === ProfissionalProfissaoTipo.Medico
      ? '../atendimentos-medicos/cadastro'
      : '../exames/audiometrias/cadastro';

    this.router.navigate([rota, { id: agendamentoSelecionado.id }], { relativeTo: this.activatedRoute })
      .then((navegou) => {
        if (navegou) {
          this.pacienteService.carregarPaciente(pacienteId).subscribe({
            next: () => {
              // Se quiser fazer algo depois de carregar, colocar aqui
            },
            error: (err) => {
              const msg = err?.error?.mensagem || 'Não foi possível carregar os dados do paciente. Tente novamente.';
              this.toast.showWarning(msg);
            }
          });
        }
      });
  }

  atualizarClick() {
    this.submetido = true;
    this.atualizar();
  }

  atualizar() {
    if (!this.modelo.valid)
      return;

    let datas = this.modelo.controls.datas.value;
    let apenasComAgendamentoVinculado = this.modelo.controls.apenasComAgendamentoVinculado.value;

    this.agendamentoService.listarAgendamentos(datas[0], datas[1], apenasComAgendamentoVinculado)
      .subscribe((agendamentos) => {
        this.registros = agendamentos;
      });
  }

  preencherDataHoje() {
    const hoje = new Date();
    this.modelo.patchValue({
      datas: [hoje, hoje]
    });

    this.atualizarClick();
  }

  //teste contexmenu
  onContextMenuOpen(args: ContextMenuOpenEventArgs): void {
    this.selectedPerson = args.rowInfo?.rowData;
  }

  //teste contextMenu
  contextMenuClick(args: MenuEventArgs): void {
    if (!this.selectedPerson) {
      this.toast.showInfo(this.translate.instant(SOLICITACAO.SELECIONAR_PACIENTE));
      return;
    }

    if (args.item.id == 'pacienteAusente') {

      this.confirm.confirm(this.translate.instant(ATENDIMENTO.NAO_COMPARECIMENTO), { height: "200" }).subscribe(
        confirmarAlteracao => {

          if (!confirmarAlteracao) {

            return;
          }

          //Chamar endpoint para mudança de status
          const entrada: NaoExecucaoDto = {

            atendimentoId: this.selectedPerson.id,
            motivoNaoExecucao: 2
          };

          this.atendimentoServico.inserirNaoExecucao(entrada).subscribe(
            () => {
              this.toast.showSuccess("Status do atendimento alterado com sucesso!");

              this.atualizar();

            },

            (err) => {
              this.toast.showError('Ops, ocorreu um problema ao alterar o status de atendimento.')
              console.log('Erro ao alterar o status: ', err);
            });
        }
      )


    }
  }

}
